import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const MaskedTitle = ({ text }) => (
  <span className="block overflow-hidden pb-3 -mb-3">
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
    >
      {text}
    </motion.span>
  </span>
);

export const PageHero = ({ eyebrow, title, subtitle, crumbs = [], image }) => (
  <section className="relative overflow-hidden bg-alabaster pt-36 pb-20 sm:pt-44 sm:pb-24">
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-[0.14]" />
        <div className="absolute inset-0 bg-alabaster/60" />
      </div>
    )}
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      {crumbs.length > 0 && (
        <motion.nav
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="flex items-center gap-1.5 text-[0.7rem] uppercase tracking-[0.2em] text-stone2 mb-8"
          aria-label="Breadcrumb"
        >
          <Link to="/" data-testid="crumb-home" className="hover:text-bronze transition-colors duration-300">
            Home
          </Link>
          {crumbs.map((c) => (
            <span key={c.label} className="flex items-center gap-1.5">
              <ChevronRight size={12} className="text-gold" />
              {c.to ? (
                <Link to={c.to} data-testid={`crumb-${c.label.toLowerCase().replace(/\s/g, "-")}`} className="hover:text-bronze transition-colors duration-300">
                  {c.label}
                </Link>
              ) : (
                <span className="text-bronze">{c.label}</span>
              )}
            </span>
          ))}
        </motion.nav>
      )}
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="text-xs uppercase tracking-[0.3em] font-medium text-bronze mb-5"
      >
        {eyebrow}
      </motion.p>
      <h1 className="font-serif font-light tracking-tight text-ink text-4xl sm:text-5xl lg:text-6xl max-w-3xl">
        <MaskedTitle text={title} />
      </h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.45 }}
          className="mt-6 text-base sm:text-lg leading-relaxed text-stone2 max-w-2xl"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
